import { HttpClient, HttpMethods } from "../types/httpClient";

function getProjectsTags(httpClient: HttpClient) {
  return () =>
    httpClient
      .sendHttpRequest<{ tags: string[] }>({
        endpoint: "/projects/tags",
        method: HttpMethods.GET,
      })
      .then(({ tags }) => tags.map((name) => ({ name })));
}

export { getProjectsTags };
